module.exports = "<div ng-repeat=\"msg in $ctrl.decodedMsg track by $index\">\n  <p> {{msg}} </p>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/input-screen/comment-box/range-form/range-form.display.html
// module id = 612
// module chunks = 0